export const initialState = {
	isSyncEnabled: true
};

export default initialState;
